export const BRAND = Object.freeze({
  FUNKO: "funko",
  LOUNGEFLY: "loungefly",
  MONDO: "mondo",
});

export const ROUTES = Object.freeze({
  HOME: "/",
  ADMIN: "/admin",
  LOGIN: "/login",
  PREVIEW: "/preview",
});

export const LOCAL_STORAGE_KEYS = Object.freeze({
  [BRAND.FUNKO]: "CONVENTION-WISHLIST-ID-FUNKO",
  [BRAND.LOUNGEFLY]: "CONVENTION-WISHLIST-ID-LOUNGEFLY",
  [BRAND.MONDO]: "CONVENTION-WISHLIST-ID-MONDO",
});

const SFCC_URL = process.env.REACT_APP_SFCC_URL || "";
export const IMAGES = {
  PRODUCT: {
    DEFAULT: `${SFCC_URL}/pop-protector.png`,
  },
  FUN_BACKGROUND: `${SFCC_URL}/Funko_Fun_BG.png`,
  LOGO: {
    [BRAND.LOUNGEFLY]: `${SFCC_URL}/loungefly-logo-white.svg`,
    [BRAND.FUNKO]: `${SFCC_URL}/funko-logo-white.svg`,
    [BRAND.MONDO]: `${SFCC_URL}/mondo-logo-white.png`,
  },
  HEART: {
    EMPTY: `${SFCC_URL}/empty-heart.svg`,
    FILLED: `${SFCC_URL}/filled-heart.svg`,
  },
};

export const SOCIALS = {
  CROWN: {
    LINK: {
      [BRAND.FUNKO]: process.env.REACT_APP_FUNKO_URL,
      [BRAND.LOUNGEFLY]: process.env.REACT_APP_LF_URL,
      [BRAND.MONDO]: process.env.REACT_APP_MONDO_URL,
    },
    IMAGE: {
      [BRAND.FUNKO]: `${SFCC_URL}/crown.svg`,
      [BRAND.LOUNGEFLY]: `${SFCC_URL}/crown.svg`,
      [BRAND.MONDO]: `${SFCC_URL}/mondo-logo-letter.png`,
    },
  },
  TOK: {
    LINK: process.env.REACT_APP_TOK_URL,
    IMAGE: `${SFCC_URL}/tok.svg`,
  },
  FB: {
    LINK: process.env.REACT_APP_FB_URL,
    IMAGE: `${SFCC_URL}/facebook.svg`,
  },
  TWITTER: {
    LINK: process.env.REACT_APP_TWITTER_URL,
    IMAGE: `${SFCC_URL}/twitter.svg`,
  },
  YT: {
    LINK: process.env.REACT_APP_YT_URL,
    IMAGE: `${SFCC_URL}/youtube.svg`,
  },
  IG: {
    LINK: process.env.REACT_APP_IG_URL,
    IMAGE: `${SFCC_URL}/instagram.svg`,
  },
};

/**
 * @desc Socket events to listen/emit.
 *  - listen for on the frontend
 *  - emit on the backend
 *  - should be EXACTLY the same on both FE/BE
 */
export var SOCKET_EVENTS = Object.freeze({
  LIVE_PRODUCTS_UPDATE: (conventionId) =>
    `(live) receive product data: ${conventionId}`,
  LIVE_CONVENTION_UPDATE: (brand) => `(live) receive convention data: ${brand}`,
  PUBLISH_CONVENTION: (brand) => `(live) receive public convention: ${brand}`,
  UNPUBLISH_CONVENTION: (brand) => `(live) remove public convention: ${brand}`,
});

export var COPY = Object.freeze({
  EMPTY_WISHLIST:
    "Looks like your wishlist is empty. Click the “Heart” icon to add items to your wishlist",
  EMPTY_CONLIST: "The convention has not started yet. Please check again later",
});

export var GA_EVENTS = Object.freeze({
  PAGE_VIEW: "PAGE_VIEW",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
});

export var GA_ID = Object.freeze({
  [BRAND.FUNKO]: "G-K4P4N2D1E1",
  [BRAND.LOUNGEFLY]: "G-96SPDHVREK",
  [BRAND.MONDO]: "G-SJ5TY7ZETF",
});

export var MODAL_ID = Object.freeze({
  CREATE_NEW_CONVENTION: "CREATE_NEW_CONVENTION_MODAL",
  DELETE_CONVENTION: "DELETE_CONVENTION_MODAL",
  ADD_NEW_PRODUCT: "ADD_NEW_PRODUCT_MODAL",
  DELETE_PRODUCT: "DELETE_PRODUCT_MODAL",
});
